/**
 * useRecentlyViewed — Stocke les 8 dernières propriétés consultées (localStorage).
 *
 * Auto-appelé depuis PropertyDetails. Utilisé par le carrousel "Vu récemment".
 */
import { useEffect, useState, useCallback } from 'react';

const KEY = 'realty237:recently_viewed';
const MAX = 8;

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

const write = (arr) => {
  try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch {/* noop */}
};

export const useRecentlyViewed = () => {
  const [items, setItems] = useState(read);

  const push = useCallback((property) => {
    if (!property) return;
    const id = property._id || property.id;
    const slim = {
      _id: id, id,
      title: property.title,
      price: property.price,
      city: property.city,
      neighborhood: property.neighborhood,
      purpose: property.purpose,
      type: property.type,
      bedrooms: property.bedrooms,
      bathrooms: property.bathrooms,
      area: property.area,
      landSize: property.landSize,
      images: property.images?.slice(0, 1) || [],
      verified: property.verified,
      ts: Date.now(),
    };
    const filtered = read().filter((p) => (p._id || p.id) !== id);
    const next = [slim, ...filtered].slice(0, MAX);
    write(next);
    setItems(next);
  }, []);

  return { items, push };
};

export default useRecentlyViewed;
